import { Card } from 'components';
import { Container, ContainerDescription, ContainerTile } from './styles';
import { NoGraphIcon } from '~/icons/NoGraphIcon';

export const NoGraph = (props): JSX.Element => {
  const { title, description } = props;

  return (
    <Container>
      <NoGraphIcon />
      <ContainerTile>
        {title}
      </ContainerTile>
      <ContainerDescription>
        { description }
      </ContainerDescription>
    </Container>
  ); };
